import React from 'react';
import { useAuth } from '../contexts/AuthContext.tsx';
import { useIsMobile } from '../hooks/useMediaQuery.ts';
import { isInAppBrowser } from '../utils/googleAuth.ts';

interface LoginModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const LoginModal: React.FC<LoginModalProps> = ({ isOpen, onClose }) => {
  const { signInWithGoogle } = useAuth();
  const isMobile = useIsMobile();
  const lang = navigator.language.toLowerCase();
  const isJa = lang.startsWith('ja');
  const isKo = lang.startsWith('ko');

  if (!isOpen) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(42,42,42,0.6)',
        backdropFilter: 'blur(4px)',
        zIndex: 99999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
        boxSizing: 'border-box',
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: '#f9f7f4',
          borderRadius: '20px',
          width: isMobile ? '100%' : '380px',
          maxWidth: '420px',
          overflow: 'hidden',
          boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
        }}
      >
        {/* 상단 브랜드 영역 */}
        <div
          style={{
            background: '#2a2a2a',
            padding: '2rem',
            textAlign: 'center',
            position: 'relative',
          }}
        >
          <button
            onClick={onClose}
            style={{
              position: 'absolute',
              top: '1rem',
              right: '1rem',
              background: 'rgba(255,255,255,0.1)',
              border: 'none',
              borderRadius: '50%',
              width: '28px',
              height: '28px',
              minWidth: '28px',
              minHeight: '28px',
              cursor: 'pointer',
              color: '#fff',
              fontSize: '1rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              padding: 0,
            }}
          >
            ×
          </button>
          <p style={{
            fontFamily: "'Crimson Text', serif",
            fontSize: '0.75rem',
            color: '#8b7355',
            letterSpacing: '2px',
            fontWeight: '700',
            margin: '0 0 0.5rem',
          }}>
            TOKYO BOOK TREE
          </p>
          <h2 style={{
            fontFamily: "'Crimson Text', serif",
            fontSize: '1.6rem',
            fontWeight: '400',
            color: '#fff',
            margin: '0 0 0.5rem',
            letterSpacing: '-0.5px',
          }}>
            책을 사랑하는 사람들의 공간
          </h2>
          <p style={{
            fontSize: '0.85rem',
            color: 'rgba(255,255,255,0.5)',
            margin: 0,
            fontStyle: 'italic',
          }}>
            도쿄에서 함께 읽고, 나누고, 연결되어요
          </p>
        </div>

        {/* 하단 로그인 영역 */}
        <div style={{ padding: '2rem' }}>
          <p style={{
            fontSize: '0.95rem',
            color: '#666',
            margin: '0 0 1.5rem',
            lineHeight: 1.7,
            textAlign: 'center',
            fontFamily: "'Crimson Text', serif",
          }}>
            로그인하고 클럽, 마켓, 이벤트를<br />자유롭게 이용해보세요.
          </p>

              <button
              onClick={async () => {
                try {
                  await signInWithGoogle();
                  onClose();
                } catch (error) {
                  console.error('로그인 오류:', error);
                  alert('로그인 중 오류가 발생했습니다.');
                }
              }}
              style={{
                width: '100%', padding: '0.9rem',
                background: '#fff', color: '#2a2a2a',
                border: '1.5px solid #e0e0e0', borderRadius: '12px',
                fontSize: '0.95rem', fontWeight: '600', cursor: 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.7rem',
                fontFamily: "'Helvetica Neue', sans-serif",
                transition: 'all 0.2s', boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.borderColor = '#8b7355';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(139,115,85,0.15)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.borderColor = '#e0e0e0';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)';
              }}
            >
              <svg width="18" height="18" viewBox="0 0 18 18">
                <path fill="#4285F4" d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.48-1.6 2.04v2.01h2.6a7.8 7.8 0 0 0 2.38-5.88c0-.57-.05-.66-.15-1.18z"/>
                <path fill="#34A853" d="M8.98 17c2.16 0 3.97-.72 5.3-1.94l-2.6-2a4.8 4.8 0 0 1-7.18-2.54H1.83v2.07A8 8 0 0 0 8.98 17z"/>
                <path fill="#FBBC05" d="M4.5 10.52a4.8 4.8 0 0 1 0-3.04V5.41H1.83a8 8 0 0 0 0 7.18l2.67-2.07z"/>
                <path fill="#EA4335" d="M8.98 4.18c1.17 0 2.23.4 3.06 1.2l2.3-2.3A8 8 0 0 0 1.83 5.4L4.5 7.49a4.77 4.77 0 0 1 4.48-3.3z"/>
              </svg>
              Google로 계속하기
          </button>

          <p style={{
            fontSize: '0.75rem',
            color: '#bbb',
            margin: '1.2rem 0 0',
            textAlign: 'center',
            lineHeight: 1.6,
          }}>
            로그인 시 <a href="/privacy" style={{ color: '#8b7355', textDecoration: 'none' }}>개인정보처리방침</a> 및{' '}
            <a href="/terms" style={{ color: '#8b7355', textDecoration: 'none' }}>이용약관</a>에 동의한 것으로 간주됩니다.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
